/**
 * This component is used to prevent agents from accessing routes
 * that only work for clients or anonymous users.
 * It should only be applied in public routes
 */

import React, { ReactElement } from "react";
import { useSelector } from "react-redux";

import { AGENT_MY_CLEANINGS_LINK } from "@config/links";
import { IS_BROWSER } from "@config/consts";

import { langFromPathname } from "@services/LangFromPathname";

import {
  isUserAgent as isUserAgentSelector,
  isUserAdmin as isUserAdminSelector,
} from "@soft/redux/user/user.selectors";
import { getLanguage } from "@soft/redux/localisation/localisation.selectors";

interface Props {
  children: React.ReactNode;
}

const AgentGuard = (props: Props): ReactElement | null => {
  const isUserAgent = useSelector(isUserAgentSelector);
  const isUserAdmin = useSelector(isUserAdminSelector);
  const language = useSelector(getLanguage) || langFromPathname();
  const isWindowAvailable = IS_BROWSER;

  if (isUserAgent && isWindowAvailable && !isUserAdmin) {
    window.location.href = `/${language}${AGENT_MY_CLEANINGS_LINK}`;
    return null;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export { AgentGuard };

AgentGuard.displayName = "AgentGuard";
